export default __webpack_public_path__ + "static/media/edit_black.b0e3d490.svg";